import Customer from "../components/customers/customer"
function Allcustomer(){
    return(
        <>
        <Customer/>
        </>
    )
}
export default Allcustomer